import { ValidationError } from '@workflows/types';

export class WorkflowImportError extends Error {
  constructor(
    public readonly failureReason: string,
    public readonly errors?: ValidationError[],
  ) {
    super(failureReason);
    this.name = 'WorkflowImportError';
  }
}
